import React from "react";
import styled, { css } from "styled-components";
var FileIcon = function FileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 .003V0h10.998C17.55 0 18 .455 18 .992v18.016a.993.993 0 0 1-.993.992H.993A1 1 0 0 1 0 18.993V6L6 .003ZM2.83 6H6V2.83L2.83 6ZM8 2v5a1 1 0 0 1-1 1H2v10h14V2H8Z"
  }));
};
FileIcon.defaultProps = {
  width: "18",
  height: "20",
  xmlns: "http://www.w3.org/2000/svg"
};
var FileTrashIcon = function FileTrashIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3.666 1.667V.333h6.667v1.334h3.333V3h-1.333v10a.666.666 0 0 1-.667.667H2.333A.667.667 0 0 1 1.666 13V3H.333V1.667h3.333ZM3 3v9.333h8V3H3Zm2 2h1.333v5.333H5V5Zm2.666 0H9v5.333H7.666V5Z"
  }));
};
FileTrashIcon.defaultProps = {
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
};
var UploadIcon = function UploadIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "m15 14.781 5.657 5.656-1.887 1.887-2.437-2.437v7.446h-2.666v-7.449l-2.438 2.44-1.886-1.887L15 14.781ZM15 .667a9.335 9.335 0 0 1 9.272 8.258 7.333 7.333 0 0 1-1.27 14.379v-2.685a4.668 4.668 0 1 0-1.483-9.214 6.668 6.668 0 1 0-13.036 0A4.667 4.667 0 0 0 6.76 20.58l.24.04v2.685A7.333 7.333 0 0 1 5.728 8.925 9.333 9.333 0 0 1 15 .667Z"
  }));
};
UploadIcon.defaultProps = {
  width: "30",
  height: "28",
  xmlns: "http://www.w3.org/2000/svg"
};
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import getIconColor from "../../../utils/getIconColor";
import getTextColor from "../../../utils/getTextColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import TextAtm from "../../atoms/TextAtm";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
export var Wrapper = styled.div.withConfig({
  componentId: "sc-3mc4yb-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    $hasError = _ref.$hasError,
    theme = _ref.theme;
  return css(["background-color:", ";padding:", ";border:", " solid ", ";border-radius:", ";"], getColor(theme, "white"), space(3), unit(1), !$hasError ? getBorderColor(theme, $onColor, "low") : getColor(theme, "error"), getBorderRadius(theme, "large"));
});
export var UploadElement = styled.div.withConfig({
  componentId: "sc-3mc4yb-1"
})(function (_ref2) {
  var theme = _ref2.theme;
  return css(["text-align:center;padding:", ";background-image:url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23B2B2B2FF' stroke-width='1' stroke-dasharray='9.5' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\");border-radius:", ";"], space(2.5), getBorderRadius(theme, "large"));
});
export var FileNameWithButton = styled(FlexContainerOrg).withConfig({
  componentId: "sc-3mc4yb-2"
})(["position:relative;flex:1;"]);
export var TextWithLines = styled(TextAtm).withConfig({
  componentId: "sc-3mc4yb-3"
})(function (_ref3) {
  var $onColor = _ref3.$onColor,
    theme = _ref3.theme;
  return css(["display:flex;justify-content:center;align-items:center;color:", ";&::before,&::after{content:\"\";width:", ";height:", ";background-color:", ";}&::before{margin-right:", ";}&::after{margin-left:", ";}"], getTextColor(theme, $onColor, "low"), space(3), unit(1), getTextColor(theme, $onColor, "low"), space(0.5), space(0.5));
});
export var StyledFileIcon = styled(FileIcon).withConfig({
  componentId: "sc-3mc4yb-4"
})(function (_ref4) {
  var $onColor = _ref4.$onColor,
    theme = _ref4.theme;
  return css(["fill:", ";"], getIconColor(theme, $onColor, "high"));
});
export var StyledFileTrashIcon = styled(FileTrashIcon).withConfig({
  componentId: "sc-3mc4yb-5"
})(function (_ref5) {
  var $onColor = _ref5.$onColor,
    theme = _ref5.theme;
  return css(["fill:", ";cursor:pointer;"], getIconColor(theme, $onColor, "high"));
});
export var StyledUploadIcon = styled(UploadIcon).withConfig({
  componentId: "sc-3mc4yb-6"
})(function (_ref6) {
  var theme = _ref6.theme;
  return css(["fill:", ";"], getColor(theme, "secondaryLight"));
});